/**
 * SportDataGatewayConfig defines configuration for sports data client.
 * @class SportDataGatewayConfig
 */
var SportDataGatewayConfig = /** @class */ (function () {
    /**
     * Creates an instance of SportDataGatewayConfig
     * @param {string} serviceUrl Sports data service URL
     * @example
     * let config = new SportDataGatewayConfig("https://sportsapi0.staging.sbtech.com");
     */
    /* istanbul ignore next */
    function SportDataGatewayConfig(serviceUrl) {
        this.serviceUrl = serviceUrl;
        this.apiEndpoint = "";
    }
    return SportDataGatewayConfig;
}());
export { SportDataGatewayConfig };
//# sourceMappingURL=SportDataGatewayConfig.js.map